import { useCallback, useMemo } from 'react';
import { useUserContext } from '../../context/user/UserContext';
import { BooleanFlagKey } from '../../../server/util/featureFlags/registry';

const useFeatureFlags = () => {
  const { data: userData } = useUserContext();

  const userFeatureFlags = useMemo(() => {
    return userData?.user?.flags ?? [];
  }, [userData?.user?.flags]);

  const isFeatureEnabled = useCallback(
    (featureFlag: Flags) => {
      return userFeatureFlags.includes(featureFlag);
    },
    [userFeatureFlags]
  );

  return {
    userFeatureFlags,
    isFeatureEnabled,
  };
};

export type Flags = BooleanFlagKey;

export default useFeatureFlags;
